import { getMeta } from '../common/common';

export const UserEvents = {
	ExerciseVideoViewed: 'ExerciseVideoViewed',
	MealPlanDayExpanded: 'MealPlanDayExpanded',
	MealPlanMealExpanded: 'MealPlanMealExpanded',
	RecipePrinted: 'RecipePrinted',
	ShoppingListPrinted: 'ShoppingListPrinted',
	ShoppingListSaved: 'ShoppingListSaved',
	WorkoutDayExpanded: 'WorkoutDayExpanded',
	WorkoutPrinted: 'WorkoutPrinted',
	WorkoutExpanded: 'WorkoutExpanded',
	WorkoutProgramPrinted: 'WorkoutProgramPrinted',
	WorkoutWeekExpanded: 'WorkoutWeekExpanded',
};

/**
 * Send tracked event.
 *
 * @param eventName
 * @param payload
 *
 * @returns {Promise<Response>}
 */
export const trackEvent = (eventName, payload) =>
	new Promise((resolve, reject) => {
		if (!UserEvents[eventName]) {
			reject(`Unsupported event name: ${eventName}`);

			return;
		}

		const eventData = {
			eventName,
			payload,
		};

		fetch('/usertracking/track-event', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Requested-With': 'XMLHttpRequest',
				'X-CSRF-TOKEN': getMeta('csrf-token'),
			},
			body: JSON.stringify(eventData),
			credentials: 'same-origin',
			redirect: 'follow',
			cache: 'no-cache',
		}).then(response => {
			if (response.ok) {
				resolve(response);
			} else {
				reject(new Error('error'));
			}
		}, err => {
			reject(new Error(err.message));
		});
	});
